import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllProfessionalsNotPaginatedUseCaseInterface } from 'domain/usecases';
import { getProfileKey } from 'domain/value-objects/profile-type';

export class RemoteGetAllProfessionalsNotPaginated
  implements GetAllProfessionalsNotPaginatedUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllProfessionalsNotPaginatedUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetAllProfessionalsNotPaginatedUseCaseInterface.Params,
  ): Promise<GetAllProfessionalsNotPaginatedUseCaseInterface.Result> {
    const { profileType, ...restParams } = params;
    const requestUrl = `${this.url}/${getProfileKey(profileType)}/0`;

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(requestUrl, restParams),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
